type Name =
  | 'home' | 'devices' | 'tag' | 'user'
  | 'device-mobile' | 'device-desktop' | 'device-laptop'
  | 'arrow-right' | 'chevron-right' | 'external-link' | 'plus'

const P: Record<Name, string> = {
  'home': 'M5 12H3l9-9 9 9h-2M5 12v7a1 1 0 0 0 1 1h3v-5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5h3a1 1 0 0 0 1-1v-7',
  'devices': 'M13 9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zM18 8V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h5M16 15h.01',
  'tag': 'M7.5 7.5h.01M3 11V4a1 1 0 0 1 1-1h7l9 9a1.5 1.5 0 0 1 0 2l-6 6a1.5 1.5 0 0 1-2 0L3 11z',
  'user': 'M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2',
  'device-mobile': 'M6 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zM11 18h2',
  'device-desktop': 'M3 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM7 20h10M9 16v4M15 16v4',
  'device-laptop': 'M3 19l18 0M5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9H5z',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  'chevron-right': 'M9 6l6 6-6 6',
  'external-link': 'M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M11 13l9-9M15 4h5v5',
  'plus': 'M12 5v14M5 12h14',
}

export function Icon({ name, size = 20, className, style }:
  { name: Name; size?: number; className?: string; style?: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
      className={className} style={style} aria-hidden="true">
      <path d={P[name]} />
    </svg>
  )
}
